import React from "react";

function RefundsProcessing() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h2>Refunds processing through dashboard</h2>
              <hr />
            </section>

            <p>
              A refund is when you have charged a payer and need to cancel the
              payment and return the funds to the payer. The funds will be
              returned to whatever payment method (credit card, bank account)
              that the payer initially used to make the payment.
            </p>

            <p>
              Refund will be initiated on the same day (provided you have
              sufficient funds in your <b>Safexpay</b> account).
            </p>

            <p>
              You can initiate refunds only on those payments that are in
              captured/Successful state. You can make full or partial refunds to
              customers.
            </p>
            <p>
              It will take around 3 to 5 business days for the refund amount to
              reflect in your customer's bank account (Excluding Saturdays,
              Sundays, and Bank Holidays).
            </p>

            <p>
              In case of Net banking transactions, certain government banks may
              take some more days.
            </p>
            <p className="para-blod">Refund Types :</p>
            <ol>
              <li>Full Refund</li>
              <li>Partial Refund</li>
            </ol>

            <p className="para-blod">Refunds can be initiated for some typical scenarios listed below:  </p>

            <p >
            Refunds are needed in all three scenarios. Before you hit the “refund” button on your dashboard or through the API. 
            </p>

            <p>
              {" "}
              <span className="para-blod">Scenario 1:</span> Customer orders
              some product and uses a credit card to pay. After a while, he/she
              cancels the order.
            </p>

            <p>
              {" "}
              <span className="para-blod">Scenario 2:</span> Your customer buys
              some online services. When the product arrives, he/she realizes
              the disinterest or misfit in the order and returns it.
            </p>

            <p>
              {" "}
              <span className="para-blod">Scenario 3:</span> Customer performs
              the mobile recharge and makes the payment online itself. He/she
              receives a transaction successful message but the recharge is not
              complete yet.
            </p>

            <p className="para-blod">
              How to Refund a transaction through Safexpay Dashboard:
            </p>
            <ol>
              <li>Single transaction Refund</li>
            </ol>

            <p className="para-blod">
              Steps to Refund the transaction through Safexpay Dashboard
            </p>
            <ul>
              <li>
                Log in to your{" "}
                <span className="para-blod">Safexpay Dashboard</span>
              </li>
              <li>
                Click on <span className="para-blod"> ‘Transactions’ Tab.</span>
              </li>
              <li>
                Please Filter the transaction according to Order ID, AG_REF(as
                per requirement) and select the transaction you want to refund.
              </li>
              <li>
                Click on <span className="para-blod"> ‘Refund’ </span> which is
                under the <span className="para-blod"> ‘Action’ tab.</span>
              </li>
            </ul>

            {/* <div className="demo-img">
              <img src="#" alt="image-pending" width="100px" className="demo-style" />
            </div> */}

            {/* <div className="demo-img mt-5">
              <img src="#" alt="image-pending" width="100px" className="demo-style"/>
            </div> */}

            <p className="img-para-div mt-3">
              On the Pop-up window, you can initiate the{" "}
              <span className="para-blod"> Full Refund </span> or{" "}
              <span className="para-blod"> Partial Refund </span> (as per
              requirement), then click on{" "}
              <span className="para-blod"> ‘Refund button’ </span> to process it
              successfully.
              {/* <div className="demo-img mt-3 ">
                <img src="#" alt="image-pending" width="100px" className="demo-style" />
              </div> */}
            </p>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  );
}
export default RefundsProcessing;
